import { DAVINCI_CDN } from '@/costants/defaultValues';

// TEMP FIX TO REMOVE AFTER CLINIC IMAGE WILL UPLOADED ON GCP
// NEED A URL MIGRATION
export const sanitizeImageUrl = (url: string) => {
  return url?.includes(DAVINCI_CDN) ? url : url?.split('?')[0];
};
